const MundActiveCampaign = (props) => (
  <svg
    width={88}
    height={56}
    viewBox="0 0 88 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3901_79873)">
      <rect
        x={3.50586}
        y={13.8579}
        width={40}
        height={40}
        rx={10}
        transform="rotate(-15 3.50586 13.8579)"
        fill="url(#paint0_linear_3901_79873)"
      />
      <g clipPath="url(#clip1_3901_79873)">
        <path
          d="M26.0792 15.3203L25.2331 16.5813C25.1145 16.7584 24.8865 16.8195 24.6952 16.7254L23.3286 16.0525C23.2192 15.9984 23.0896 15.9927 22.9786 16.0391C22.2997 16.3211 21.6264 16.6683 20.9653 17.079C17.4753 19.2486 15.2685 23.0549 15.1152 27.1759C14.8352 34.8438 20.5862 40.3951 27.1845 40.8292C28.5439 40.9177 29.9407 40.7913 31.3287 40.4194C32.7167 40.0475 33.9895 39.4585 35.1226 38.7021C39.5819 35.7223 41.8736 30.0988 40.4037 24.6133C38.7165 18.3163 32.6433 14.3431 26.375 15.1314C26.2535 15.1473 26.1435 15.2149 26.0742 15.3193L26.0792 15.3203ZM18.1575 31.7825L18.1591 31.7797L21.9777 30.7565C22.1781 30.8672 22.295 30.9312 22.4932 31.0425C23.3447 33.6623 24.4831 35.8834 25.7506 37.5147C26.0005 37.8362 25.705 38.2919 25.3123 38.1898C22.1259 37.3396 19.4068 35.0106 18.1536 31.7859L18.1575 31.7825ZM30.804 38.1601C30.778 38.1694 30.7537 38.176 30.7293 38.1825C30.705 38.189 30.6806 38.1955 30.6535 38.2004C29.2136 38.4671 26.476 35.7236 24.7369 30.4818C24.6605 30.2497 24.795 29.9992 25.0297 29.9363L31.5423 28.1913C31.7769 28.1284 32.0187 28.2781 32.0686 28.5173C33.1834 33.9263 32.1821 37.6717 30.804 38.1601ZM35.4221 35.4809C35.1358 35.7673 34.6515 35.5181 34.7049 35.1154C35.0002 32.9677 34.8463 30.3302 34.1999 27.4839C34.1993 27.4817 34.2015 27.4811 34.2015 27.4811L33.7111 25.6511C33.6504 25.4243 33.4172 25.289 33.1914 25.3495L18.0256 29.4132C17.771 29.4814 17.5209 29.3006 17.4928 29.0364C17.1496 25.7896 18.3309 22.6275 20.5527 20.4092C20.8412 20.1222 21.3239 20.3742 21.2689 20.7798C21.0637 22.2718 21.0762 24.001 21.3177 25.8762C21.35 26.1297 21.6038 26.2976 21.8495 26.2318L23.2685 25.8516C23.4722 25.797 23.6037 25.5973 23.5783 25.3873C23.0544 21.0592 23.9684 18.157 25.1708 17.73L25.3191 17.6903C26.5739 17.4589 28.8188 19.5146 30.527 23.5254C30.6099 23.72 30.8215 23.8278 31.0274 23.7726L32.4441 23.393C32.6898 23.3271 32.8263 23.057 32.7269 22.8191C32.0035 21.0754 31.1475 19.5722 30.2254 18.3799C29.9755 18.0584 30.2692 17.596 30.6603 17.7009C33.8389 18.5484 36.5506 20.8675 37.808 24.0815C37.8128 24.0993 37.8197 24.1165 37.8245 24.1343L38.4114 26.3245C38.4161 26.3423 38.4209 26.3601 38.4234 26.3784C38.9415 29.7906 37.7505 33.1554 35.4215 35.4787L35.4221 35.4809Z"
          fill="url(#paint1_linear_3901_79873)"
        />
      </g>
    </g>
    <path
      d="M41.7163 18.9599C43.1658 13.5502 43.8906 10.8454 45.497 9.06127C46.9101 7.4919 48.7837 6.41017 50.8494 5.9711C53.1977 5.47195 55.9025 6.19671 61.3122 7.64623L69.0396 9.71678C74.4493 11.1663 77.1542 11.8911 78.9383 13.4975C80.5077 14.9106 81.5894 16.7842 82.0285 18.8498C82.5276 21.1982 81.8029 23.903 80.3533 29.3127L78.2828 37.0401C76.8333 42.4498 76.1085 45.1546 74.5021 46.9388C73.089 48.5081 71.2154 49.5899 69.1497 50.0289C66.8014 50.5281 64.0966 49.8033 58.6869 48.3538L50.9595 46.2833C45.5498 44.8337 42.8449 44.109 41.0608 42.5025C39.4914 41.0895 38.4097 39.2159 37.9706 37.1502C37.4715 34.8019 38.1962 32.097 39.6458 26.6873L41.7163 18.9599Z"
      fill="url(#paint2_linear_3901_79873)"
    />
    <path
      d="M69.1974 28.6032C68.9235 28.1861 57.1226 13.6246 56.5688 13.018L56.4062 12.8025L55.7045 15.4213C55.4754 16.2765 55.815 16.6539 56.2145 17.2192L56.303 17.3003C56.8794 18.0276 65.2957 28.3597 66.4115 29.7471C64.7515 30.3907 52.1139 35.196 51.331 35.4446C50.3653 35.7586 50.2136 36.119 50.0132 36.8673L49.3401 39.3792C49.3401 39.3792 67.9379 32.2756 68.3179 32.091C69.1808 31.7494 69.5212 31.0959 69.6358 30.6683L69.7217 30.3477C69.8649 29.8132 69.6997 29.1961 69.1974 28.6033L69.1974 28.6032Z"
      fill="url(#paint3_linear_3901_79873)"
    />
    <path
      d="M59.2708 29.094C59.682 29.2042 60.1363 29.154 60.6335 28.9436C61.2478 28.7072 61.7963 28.5105 61.7963 28.5105L61.9792 28.4449L61.8536 28.2968C61.8164 28.2294 56.297 21.4805 55.7062 20.8066C55.4694 20.4568 55.0724 20.2931 54.7724 20.3845C54.4724 20.476 54.1953 20.6881 54.0807 21.1157L53.6367 22.7726L53.6739 22.8399C53.711 22.9072 57.4867 27.5277 58.2401 28.417C58.5798 28.7944 58.911 28.9977 59.2708 29.0941L59.2708 29.094Z"
      fill="url(#paint4_linear_3901_79873)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3901_79873"
        x1={23.5059}
        y1={13.8579}
        x2={23.5059}
        y2={53.8579}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#29282C" />
        <stop offset={1} stopColor="#100F11" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3901_79873"
        x1={10.6945}
        y1={13.8571}
        x2={35.8067}
        y2={35.4543}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.65} />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3901_79873"
        x1={65.1759}
        y1={8.68151}
        x2={54.8232}
        y2={47.3185}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1589FA" />
        <stop offset={1} stopColor="#004DFF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3901_79873"
        x1={57.7388}
        y1={7.30987}
        x2={73.2573}
        y2={31.9989}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.65} />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3901_79873"
        x1={54.6533}
        y1={18.6942}
        x2={56.8871}
        y2={28.5778}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.65} />
      </linearGradient>
      <clipPath id="clip0_3901_79873">
        <rect
          x={3.50586}
          y={13.8579}
          width={40}
          height={40}
          rx={10}
          transform="rotate(-15 3.50586 13.8579)"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_3901_79873">
        <rect
          width={30}
          height={30}
          fill="white"
          transform="translate(9.63086 17.3936) rotate(-15)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default MundActiveCampaign;
